module.exports = __webpack_public_path__ + "img/brand-09.4c5a836d.png";